module.exports = __webpack_public_path__ + "img/SEJ enventos_logo_Jalisco-blanco.32c2b50e.svg";